import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Made By Krishal Basnet</div>;
}

export default Footer;